export default "__VITE_ASSET__DPr_gX5I__"